// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"cfa36574652cfbe45544","777":"3e01b80aeff15142d995","939":"850841657d3d07ff922a"}[chunkId] + ".js";
};